//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "staffentrycommunityinfo",
  props: {
    //业务数据
    record: {
      type: Object,
      default: () => ({})
    },
    //流程数据
    process: {
      type: Object,
      default: () => ({})
    },
    //规则绑定
    rules: {
      type: Object,
      default: () => ({})
    },
    //自定义的参数
    config: {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    /**
     * 校验社团信息时间
     */
    async checktcommutime(){
      var len = this.record.communityrow.length;
        var flag = true;
        for(let i = 0 ; i < len; i++ ){
          if(this.record.communityrow[i].communitybegintime !=null && this.record.communityrow[i].communitybegintime != ''
            && this.record.communityrow[i].communityendtime !=null && this.record.communityrow[i].communityendtime != ''){
                let begintime = this.forMatDate(this.record.communityrow[i].communitybegintime);
                let endtime = this.forMatDate(this.record.communityrow[i].communityendtime);  
                if (begintime > endtime) {
                  flag = false
                }
          }
        }
        return flag;
    }
  },
}




// WEBPACK FOOTER //
// ./src/pcpage/hr/personnel/staffentry/staffentrycommunityinfo.vue